// dot_show: false,
// number_show: false,

export const typeofbacteria_qpt_kids = {
    core_bacteria: [
        'Bacteroidetes phylum',
        'Clostridium cluster IV'
    ],
    harmful_bacteria: [
        'Ruminococcus bromii',
        'Staphylococcus aureus'
    ],
    beneficial_bacteria: [
        'Bifidobacterium bifidum',
        'Bifidobacterium longum',
        'Lactobacillus acidophilus',
        'Lactobacillus paracasei',
        'Lactobacillus plantarum',
        'Lactobacillus rhamnosus'
    ],
}

export const typeofbacteria_qptsm_kids = {
    core_bacteria: [
        'Bacteroidetes phylum',
        'Clostridium cluster IV'
    ],
    harmful_bacteria: [
        'R. bromii',
        'S. aureus'
    ],
    beneficial_bacteria: [
        'B. bifidum',
        'B. longum',
        'L. acidophilus',
        'L. paracasei',
        'L. plantarum',
        'L. rhamnosus'
    ],
}

export const scoreConfig_AllergyandEczema_allergy_kids = [
    {
        titel: `Asthma`,
        match_key: 'Asthma',
        Xdotpos: 177,
        Ydotpos: 715,
        Xnumberpos: 580,
        Ynumberpos: 690,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 13,
        dot_show: false,
        number_show: false,
        value_use: [
            'Bifidobacterium bifidum',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Eczema`,
        match_key: 'Eczema',
        Xdotpos: 177,
        Ydotpos: 920,
        Xnumberpos: 580,
        Ynumberpos: 895,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 13,
        dot_show: false,
        number_show: false,        
        value_use: [
            'Ruminococcus bromii',
            'Staphylococcus aureus',
            'Bifidobacterium bifidum',
            'Lactobacillus acidophilus',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Food allergy`,
        match_key: 'Food allergy',
        Xdotpos: 177,
        Ydotpos: 816,
        Xnumberpos: 580,
        Ynumberpos: 790,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 13,
        dot_show: false,
        number_show: false,            
        value_use: [
            'Staphylococcus aureus',
            'Bacteroidetes phylum',
            'Bifidobacterium bifidum',
            'Bifidobacterium longum',
            'Lactobacillus plantarum',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
]
